// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ve_L","title":"styles_title__2RgXx"};